import axios from "axios";
import config from 'config';

import {
  GET_DETAILS,
  UPDATE_SITE_CONTACT,
  UPDATE_STREET_VIEW,
  UPDATE_RA
} from "./jobActionTypes";

const jobActions = (dispatch) => {
  const getDetails = async (sessionId) => {
    let jobDetails = await _getDetails(sessionId);
    dispatch({
      type: GET_DETAILS,
      payload: jobDetails
    });
  };

  const updateSiteContact = async (sessionId, siteContact, siteContactPh, siteContactNotes) => {
    return new Promise(async (resolve, reject) => {
      await _updateSiteContact(sessionId, siteContact, siteContactPh, siteContactNotes);
      dispatch({
        type: UPDATE_SITE_CONTACT,
        payload: { siteContact, siteContactPh, siteContactNotes }
      });
      resolve();
    });
  }

  const updateStreetView = async (sessionId, streetViewUrl) => {
    await _updateStreetView(sessionId, streetViewUrl);
    dispatch({
      type: UPDATE_STREET_VIEW,
      payload: streetViewUrl
    });
  };

  const updateRa = async (sessionId, ra) => {
    await _updateRa(sessionId, ra);
    dispatch({
      type: UPDATE_RA,
      payload: ra
    })
  }

  return { getDetails, updateSiteContact, updateStreetView, updateRa };
};

const _updateRa = (sessionId, ra) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/UpdateRa?sessionId=${sessionId}&ra=${ra}`,
      method: "POST"
    }).then((response) => {
      resolve();
    }).catch((response) => {
      console.log("Error updating RA", response);
      reject();
    });
  })
}

const _updateStreetView = (sessionId, streetViewUrl) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/UpdateStreetView?sessionId=${sessionId}&streetViewUrl=${streetViewUrl}`,
      method: "POST"
    }).then((response) => {
      resolve();
    }).catch((response) => {
      console.log("Error updating street view", response);
      reject();
    });
  });
}

const _getDetails = (sessionId) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/GetDetails?sessionId=${sessionId}`,
      method: "GET"
    }).then((response) => {
      resolve(response.data);
    }).catch((response) => {
      console.log("Error getting Job Details", response);
      reject();
    });
  });
}

const _updateSiteContact = async (sessionId, siteContact, siteContactPh, siteContactNotes) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Jobs/UpdateSiteContact?sessionId=${sessionId}&siteContact=${siteContact}&siteContactPh=${siteContactPh}&siteContactNotes=${encodeURIComponent(siteContactNotes)}`,
      method: "POST"
    }).then((response) => {
      resolve();
    }).catch((response) => {
      console.log("Error getting Job Details", response);
      reject();
    });
  });
}


export default jobActions;